<template>
  <div class="container">
    <div class="row">
      <div class="col-12">
        <!-- <alert id="myAlert" :type="alert.type" :text="alert.text" /> -->
        <div class="page-header"><h1>ติดต่อเรา</h1></div>
        <div class="custom-card">
          <div class="card-header">
            <h4 class="card-title">เพิ่มติดต่อเรา</h4>
          </div>
          <div class="card-body">
            <editor v-model="contact" value="contact"></editor>
          </div>
        </div>
        <div class="mt-5 text-center  ">
          <a
            href="#"
            class="btn btn-lg btn-gradient-primary"
            @click.prevent="updateContact"
            >บันทึก</a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Editor from '@/components/Editor'

export default {
  name: 'contactSetting',
  components: { Editor },
  props: {},
  data() {
    return {
      contact: '',
      alert: {
        type: 'success',
        text: ''
      }
    }
  },
  computed: {},
  created() {
    this.fetchAppData()
  },
  methods: {
    fetchAppData() {
      axios.get('/api/admin/applications').then(res => {
        this.contact = res.data.data.address
      })
    },
    updateContact() {
      let form = new FormData()
      form.append('address', this.contact)
      form.append('_method', 'patch')
      axios.post('/api/admin/applications', form).then(res => {
        swal({
          title: '',
          text: 'บันทึกสำเร็จ',
          icon: 'success',
          buttons: false,
          timer: 3000
        })
        this.fetchAppData()
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>
